import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Popover } from 'antd';
import { RootStore } from '@/models';
import ActionBtn from '../ActionBtn';
import styles from './index.less';
import { useBoolean } from 'ahooks';
import { InterpretationStatus } from '@/models/simultaneousInterpretation';
import classNames from 'classnames';
import SwitchChannel from '../../SwitchChannel';
import SwitchLanguage from '../../SwitchLanguage';
import { Tooltip } from '@/components';

interface Props extends Partial<Pick<RootStore, 'meeting'>> {
  meeting?: RootStore['meeting'];
  simultaneous?: RootStore['simultaneousInterpretation'];
  className?: string;
}
const SimultaneousInterpretationBtnPc: React.FC<Props> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    simultaneous: store.simultaneousInterpretation,
  };
})(
  observer((props) => {
    const { meeting, simultaneous, className } = props;
    const { formatMessage } = useIntl();
    const [AIICSetShow, { toggle: AIICToggle }] = useBoolean(false);

    return (
      <>
        {meeting?.ableAppsMap.Interpretation &&
        !!meeting?.hostUid &&
        simultaneous?.interpretationStatus === InterpretationStatus.starting ? (
          <Popover
            overlayClassName="oj7YZbAO5p"
            placement="topLeft"
            content={<SwitchChannel />}
            visible={AIICSetShow}
            trigger="click"
            onVisibleChange={() => {
              AIICToggle();
            }}
          >
            <Tooltip title={formatMessage({ id: 'interpretationBtnTooltip' })}>
              <div className={classNames(styles.btnWrapper)}>
                <SwitchLanguage />
                <span className={styles.title}>{formatMessage({ id: 'INTERPRETATION' })}</span>
              </div>
            </Tooltip>
          </Popover>
        ) : null}
      </>
    );
  })
);

export default SimultaneousInterpretationBtnPc;
